import React, { PropTypes } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import isEqual from 'lodash/isEqual';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import SearchActions from '../../actions/SearchActions';
import SearchPrintList from '../../components/search/SearchPrintList';
import DocumentHeadContainer from '../DocumentHeadContainer';
import { searchResultBibSelector } from '../../selectors/SearchSelector';

class PrintSearchContainer extends BcReactComponent {
  static fetchInitialData(params, query, store) {
    return [
      store.dispatch(SearchActions.performSearch({ ...query, print: true }))
    ];
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.location.query, nextProps.location.query)) {
      this.props.searchActions.performSearch({ ...nextProps.location.query, print: true });
    }
  }

  render() {
    const { pagination, results, searchActions, intl, isFetching, location } = this.props;

    return (
      <div className="cp-print-list">
        <DocumentHeadContainer pageTitle={intl.formatMessage({ id: 'searchTitle' })} />
        <SearchPrintList
          isFetching={isFetching}
          results={results}
          pagination={pagination}
          searchActions={searchActions}
          searchQuery={Immutable.fromJS(location.query)} />
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  const catalogSearch = state.getIn(['search', 'catalogSearch']);
  return {
    pagination: catalogSearch.get('pagination'),
    // FIXME: This ignores FRBR
    results: searchResultBibSelector(state).map((result) => result.representative),
    isFetching: catalogSearch.get('isFetching')
  };
};

const mapDispatchToProps = dispatch => ({
  searchActions: bindActionCreators(SearchActions, dispatch)
});

PrintSearchContainer.propTypes = {
  pagination:     ImmutablePropTypes.map,
  results:        ImmutablePropTypes.list,
  searchQuery:    ImmutablePropTypes.map,
  searchActions:  PropTypes.objectOf(PropTypes.func).isRequired,
  intl:           intlShape,
  isFetching:     PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PrintSearchContainer));



// WEBPACK FOOTER //
// ./app/containers/print/PrintSearchContainer.jsx